module.exports = __webpack_public_path__ + "static/media/edit-icon.e0fa30c6.svg";